import React from "react"

class FeedbackPage extends React.Component {
  render() {
    return (
      <div>
        <i className="fa-solid fa-circle-check" />
        <h3 className="text-center">Thank you for your review!</h3>
        <p className="final-p center">
          If you are looking to make more reservations, head back to{" "}
          <a href={`/explore`}>Dockwa.com</a> and explore some more top rated
          marinas!
        </p>
      </div>
    )
  }
}

export default FeedbackPage
